import { useState } from "react";
import { categories, trends } from "@/mocks/chigua";

export default function Trending() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? trends : trends.filter((t) => t.category === active);

  return (
    <section id="reyi" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-900">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              今日热议
            </p>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              大家都在围观什么
            </h2>
          </div>
          <div className="w-full overflow-x-auto no-scrollbar md:w-auto">
            <div className="flex items-center gap-2 md:justify-end">
              {categories.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setActive(c)}
                  className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                    active === c
                      ? "bg-foreground-900 text-background-50"
                      : "bg-background-50 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((t, i) => (
            <article
              key={t.id}
              className="flex flex-col rounded-2xl border border-background-200/80 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:shadow-soft"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-2xl font-black text-primary-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-600">
                  <i className="ri-fire-fill" aria-hidden="true"></i>
                  {t.hot}
                </span>
              </div>
              <h3 className="mt-3 text-[15px] font-semibold leading-snug text-foreground-950">{t.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{t.summary}</p>
              <div className="mt-4 flex flex-wrap items-center gap-1.5">
                {t.platforms.map((p) => (
                  <span key={p} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                    {p}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="rounded-full bg-background-100 px-2 py-0.5">{t.category}</span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {t.time}
                </span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500">
          * 榜单热度为各平台讨论量参考，热点方向随时变化，请以平台实时热搜为准。
        </p>
      </div>
    </section>
  );
}